import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import styled from 'styled-components';
import {Box, BoxButton, MainHeading} from '../../StyledComponents';
import BubbleChart from './BubbleChart'

const BubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const BubbleChartDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /*min-height: 160px;
  min-width: 300px;*/
`


class KeyFocusImprovements extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { data, user } = this.props;

    if (!data) {
      return <Box/>;
    };

    const property = data.sentimentData && data.sentimentData.highestPotentialVar && data.sentimentData.highestPotentialVar.id;
    const sentimentSettings = user.client && user.client.industryThemeSettings;
    let keywords = [];

    // Make array into object
    let hints = [];
    _.each(sentimentSettings, function(row, i) {
      let hint = {};
      _.each(row, function(col,i) {
        hint[col.type] = col.value
      });
      hints.push(hint);
    })

    let bubbleData = [];
    let bubble = [];

    _.each(hints, function(obj, i) {
      bubble.push({
        _id: obj.param,
        value: obj.weight, //100
        selected: true
      })
    });

    bubbleData.push(bubble);

    return (
      <Box>
        <MainHeading>Important subjects in your industry</MainHeading>
        <BubbleContainer>
          <BubbleChartDiv><BubbleChart data={bubbleData[0]} colorIndex={0}/></BubbleChartDiv>
        </BubbleContainer>
      </Box>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default withRouter(connect(mapStateToProps, {})(KeyFocusImprovements));



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/KeyFocusIndustry.js